import { CloudDownloadOutlined, DeleteFilled } from "@ant-design/icons";
import { Button, Popconfirm, Spin } from "antd";
import { clsx } from "clsx";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { downloadAttachment, getImageByUrl } from "../../Common";
import { deleteFile, getDirectory, getFiles } from "../../redux/action/file";
import {
  downloadAndDecryptFile,
  formatDateToYYYYMMDD,
  formatFileSize,
} from "../../utils/common";
import { useSelector } from "react-redux";
import { debugLog } from "../../utils/debugLog";
import { useTranslation } from "react-i18next";

const FileFolderCard = ({
  name,
  isSub = false,
  icon = true,
  isNav = false,
  directory,
  thumbnailUrl,
  isHeader = false,
  actualImage,
  ext,
  fileId,
  itemCount,
  fileSize,
  fileDate,
}) => {
  const [isImageLoaded, setIsImageLoaded] = useState(false);
  const [thumbnail, setThumbnail] = useState("");
  const [isDeleting, setIsDeleting] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();

  const handleClick = async (name) => {
    if (isNav === "folder") {
      const fileName = name?.toLowerCase();
      await getDirectory(fileName);
      navigate(`/cloud/${fileName}`);
    } else if (isNav === "file") {
      const path = location.pathname.split("/").pop();
      localStorage.setItem(
        "fileDirectory",
        JSON.stringify({ path, directory })
      );
      getFiles(path, directory);
      navigate("/cloud/files");
    }
  };

  const handleDownload = async (e) => {
    e.stopPropagation();
    try {
      if (actualImage) {
        await downloadAndDecryptFile(actualImage, name);
      }
    } catch (error) {
      console.error("Download failed:", error);
    }
  };

  const handleDelete = async (e) => {
    e.stopPropagation();
    setIsDeleting(true);
    try {
      await deleteFile(fileId);
      // Refresh the current directory or update state
    } catch (error) {
      console.error("Delete failed:", error);
    } finally {
      setIsDeleting(false);
    }
  };

  useEffect(() => {
    const getThumb = async () => {
      if (thumbnailUrl) {
        try {
          const res = await getImageByUrl(thumbnailUrl);
          setThumbnail(res);
        } catch (error) {
          console.error("Failed to load thumbnail:", error);
          setIsImageLoaded(true);
        }
      }
    };

    if (isSub && thumbnailUrl) {
      getThumb();
    }
  }, [thumbnailUrl, isSub]);

  debugLog("🚀 ~ thumbnail:", "log", thumbnailUrl);

  // Determine card class based on folder type and navigation type
  const cardClassName = clsx("media-card", {
    "media-card--folder": isNav === "folder",
    "media-card--file": isNav === "file",
    [name?.toLowerCase()]: isNav === "folder", // Add folder-specific class
  });

  // Format the display name
  const displayName = name?.includes("(") ? name : `${name}`;
  const formattedSize = fileSize ? formatFileSize(fileSize) : null;
  const formattedDate = fileDate ? formatDateToYYYYMMDD(fileDate) : null;

  return (
    <div className={cardClassName} onClick={() => handleClick(name)}>
      {/* Thumbnail Section */}
      <div className="media-card__thumbnail">
        {!isImageLoaded && thumbnailUrl && (
          <div className="loading-spinner">
            <Spin size="large" />
          </div>
        )}

        {thumbnail && (
          <img
            src={thumbnail}
            alt={displayName}
            onLoad={() => setIsImageLoaded(true)}
            onError={() => setIsImageLoaded(true)}
            style={!isImageLoaded ? { visibility: "hidden" } : {}}
          />
        )}

        {/* Hover overlay */}
        <div className="media-card__overlay" />

        {/* Item count badge for folders */}

        {/* Action buttons - only show for files */}
      </div>

      {/* Content Section */}
      <div className="media-card__content">
        <div className="media-card__header">
          <h3 className="media-card__title font-color" title={displayName}>
            {displayName}
          </h3>
          {itemCount && (
            <div className="media-card__count">{itemCount || "-"}</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default FileFolderCard;
